<input [disabled]="disabled" class="form-control rounded-0 rbv-field"
       [readonly]="true" value="{{dueDate | date: 'MMM dd, yyyy'}}"/>
<template #target></template>
